'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'city';
var width = 640;
var height = 512;
var aliases = [127961];
var unicode = 'f64f';
var svgPathData = 'M80 8l0-8L64 0l0 8 0 56L8 64 0 64l0 8L0 504l0 8 8 0 216 0 0-16L16 496 16 80l48 0 16 0 80 0 16 0 48 0 0-16-48 0 0-56 0-8L160 0l0 8 0 56L80 64 80 8zM496 160l-16 0 0-16 0-128 0-16L464 0 272 0 256 0l0 16 0 144 0 336 0 16 16 0 208 0 144 0 16 0 0-16 0-320 0-16-16 0-128 0zM464 16l0 144 0 16 16 0 144 0 0 320-144 0-208 0 0-336 0-144 192 0zM328 408l8 0 64 0 8 0 0-8 0-64 0-8-8 0-64 0-8 0 0 8 0 64 0 8zm16-16l0-48 48 0 0 48-48 0zM336 72l-8 0 0 8 0 64 0 8 8 0 64 0 8 0 0-8 0-64 0-8-8 0-64 0zm8 64l0-48 48 0 0 48-48 0zM328 280l8 0 64 0 8 0 0-8 0-64 0-8-8 0-64 0-8 0 0 8 0 64 0 8zm16-16l0-48 48 0 0 48-48 0zM496 440l64 0 8 0 0-8 0-64 0-8-8 0-64 0-8 0 0 8 0 64 0 8 8 0zm56-64l0 48-48 0 0-48 48 0zm-64-64l8 0 64 0 8 0 0-8 0-64 0-8-8 0-64 0-8 0 0 8 0 64 0 8zm16-16l0-48 48 0 0 48-48 0zM80 344l64 0 8 0 0-8 0-64 0-8-8 0-64 0-8 0 0 8 0 64 0 8 8 0zm8-64l48 0 0 48-48 0 0-48zM72 216l8 0 64 0 8 0 0-8 0-64 0-8-8 0-64 0-8 0 0 8 0 64 0 8zm16-16l0-48 48 0 0 48-48 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCity = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;